import { PageCollapsibleBlock } from '@servicetitan/cp-ui';
import { CustomerPortalSignableDocuments } from '@servicetitan/signable-documents';
import axios from 'axios';
import { FC, SyntheticEvent, useEffect, useState } from 'react';

interface DashboardSignableDocumentsProps {
    className?: string;
}

const LIST_URL = '/api/cp/signable-documents/list';

/*
 * My Tasks host for the customer-portal-list MFE (all accessible docs).
 * Job page uses CustomerPortalSignableDocumentsTable with a jobId instead.
 */
export const DashboardSignableDocuments: FC<DashboardSignableDocumentsProps> = ({ className }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const controller = new AbortController();

        axios
            .post<{ totalCount?: number; items?: unknown[] }>(
                LIST_URL,
                { page: 1, pageSize: 1, signableOnly: true, sort: 2 },
                { withCredentials: true, signal: controller.signal }
            )
            .then(({ data }) => setCount(data.totalCount ?? data.items?.length ?? 0))
            .catch(() => {
                // Keep last known count on transient failures.
            });

        return () => controller.abort();
    }, []);

    const onViewAllClick = (e?: SyntheticEvent<HTMLElement>) => {
        e?.preventDefault();
        e?.stopPropagation();
    };

    return (
        <PageCollapsibleBlock
            hideViewAllButton
            icon="description"
            title="Signable Documents"
            count={count}
            allRecordsHref="/"
            loading={false}
            onAllRecordsClick={onViewAllClick}
            className={className}
            data-tracking-component="portal-dashboard-signable-documents"
            data-cy="dashboard-signable-documents"
        >
            <CustomerPortalSignableDocuments signableOnly sort="action" />
        </PageCollapsibleBlock>
    );
};
